import config from '@project/config';

const baseUrl = `${config.apiUrl()}/DailyCalls`;

export default {
  dailyCallsUrl: (): string => baseUrl,
  getBaseContentUrl: (): string => `${baseUrl}/content`,
  getBaseHistoryContentUrl: (): string => `${baseUrl}/history-content`,
  repopulateDailyCallsUrl: (): string => `${baseUrl}/repopulate`,
  doNotContact: (): string => `${baseUrl}/update-contact-status`,
  callContactDoNotContactCheck: (): string => `${baseUrl}/call-contact-do-not-contact-check`,
};
